import { CALLS_SUBPATHS } from 'Constants/routing';
import { MobXProviderContext } from 'mobx-react';
import { ContactModelV2 } from 'Models/ContactModelV2';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { RootStoreProps } from 'Stores/RootStore.types';
import { isCurrentPath } from 'Utils/routeUtils';

type ViewCallHistoryParams = {
  contact?: ContactModelV2 | null;
  phoneNumber?: string | null;
};

/**
 * Entry point for "View call history" actions (contact and conversation details panel).
 *
 * - Sets CallLogsStore.pendingFilter, which useCallLogsSearch applies through
 *   its normal handleChange path.
 * - Pass `contact` to filter by all of its numbers/extensions.
 * - Pass `phoneNumber` instead when there's no resolved contact.
 * - Navigates to All Calls, unless already on that tab.
 */
export const useViewCallHistory = () => {
  const navigate = useNavigate();
  const { callLogsStore } =
    React.useContext<RootStoreProps>(MobXProviderContext);

  return useCallback(
    ({ contact, phoneNumber }: ViewCallHistoryParams) => {
      if (contact) {
        callLogsStore.setPendingFilter({ type: 'contact', contact });
      } else if (phoneNumber) {
        callLogsStore.setPendingFilter({ type: 'phone', phoneNumber });
      } else {
        return;
      }

      if (!isCurrentPath(CALLS_SUBPATHS.ALL)) {
        void navigate(CALLS_SUBPATHS.ALL);
      }
    },
    [callLogsStore, navigate]
  );
};
